import { Action } from 'store/store';
import { Currency } from 'app/currencies/store/CurrencyState';

export enum CurrencyActionType {
    SET_CURRENCIES = 'CURRENCY_SET_CURRENCIES',
}

export interface SetCurrenciesPayload {
    currencies: Currency[];
}

export type CurrencyActionSetCurrencies = Action<
    CurrencyActionType.SET_CURRENCIES,
    SetCurrenciesPayload
>;

export const setCurrencies: (
    currencies: Currency[]
) => CurrencyActionSetCurrencies = (currencies) => ({
    type: CurrencyActionType.SET_CURRENCIES,
    payload: { currencies },
});

export type CurrencyAction = CurrencyActionSetCurrencies;
